"use client";

// eslint-disable-next-line no-restricted-imports
import Link from "next/link";
import React, { ComponentProps, MouseEventHandler } from "react";
import { UrlObject } from "url";
import { usePathname } from 'next/navigation';
import { dispatchRouteChangeEvent } from '@/utils/routeEvents';

export interface INextLinkProps extends Omit<ComponentProps<typeof Link>, "href"> {
  href: string | UrlObject;
}
export default function NextLink({ href, className, children, onClick, ...props }: INextLinkProps) {
  const pathname = usePathname();

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    onClick?.(e);

    if (
      e.metaKey || // Cmd + Click (Mac)
      e.ctrlKey || // Ctrl + Click (Windows/Linux)
      e.shiftKey || // Shift + Click (Opens in a new window)
      e.button === 1 // Middle mouse button click
    ) {
      return; // Don't emit the event
    }

    if (pathname !== href) {
      dispatchRouteChangeEvent("start");
    }
  };

  return (
    <Link
      className={className}
      href={href}
      {...props}
      onClick={handleClick}
    >
      {children}
      {/* {append} */}
    </Link>
  );
}